module.exports = __webpack_public_path__ + "static/carousel-4-55bbc013549714d908af6de1eae9cf33.png";